import { FirestoreDocument, FirestoreField } from '../../types';
import { getFieldType } from '../../utils';

export type PeekFieldType = 'array' | 'map';

export function hasTimestamps(doc: FirestoreDocument): boolean {
  return !!(doc.createTime || doc.updateTime);
}

export function isFieldPeekable(fieldType: FirestoreField['type']): boolean {
  return fieldType === 'array' || fieldType === 'object';
}

/** Maps Firestore field type to peek panel type ('array' | 'map'). Use only when isFieldPeekable is true. */
export function toPeekFieldType(fieldType: FirestoreField['type']): PeekFieldType {
  return fieldType === 'array' ? 'array' : 'map';
}

export function getSubcollectionDocLabel(count: number): string {
  return count === 1 ? '1 doc' : `${count} docs`;
}

export interface DocumentFieldEntry {
  key: string;
  value: unknown;
  fieldType: FirestoreField['type'];
  isClickable: boolean;
}

export function getDocumentFieldEntries(data: FirestoreDocument['data']): DocumentFieldEntry[] {
  return Object.entries(data).map(([key, value]) => {
    const fieldType = getFieldType(value);
    const isClickable = isFieldPeekable(fieldType);
    return { key, value, fieldType, isClickable };
  });
}
